export default {
  methods: {
    platformIconName: function (platform) {
      switch (platform) {
        case 'facebook':
          return 'brands/facebook'
          break
        case 'twitter':
        case 'twitterDM':
          return 'brands/twitter'
          break
        case 'messenger':
          return 'brands/facebook-messenger'
          break
        case 'WhatsApp':  
        case 'whatsapp':
        case 'whatsapp_official':
        case 'whatsapp_twilio':
        case 'whatsapp_infobip':
          return 'brands/whatsapp'
          break
        case 'sandbox':
          return 'vial'
          break
        case 'h4mail':
          return 'brands/google'
        case 'telegram':
          return 'paper-plane'
        case 'sendgrid':
          return 'envelope-open-text'
        case 'voip':
          return 'phone-volume'
        default:
          return 'comment'
      }
    },
    platformColor: function (platform, opacity = 1) {
      switch (platform) {
        case 'facebook':
          return `rgba(66, 103, 178, ${opacity})`
          break
        case 'twitter':
        case 'twitterDM':
          return `rgb(29, 161, 242, ${opacity})`
          break
        case 'messenger':
          return `rgba(0, 153, 255, ${opacity})`
          break
        case 'WhatsApp':
        case 'whatsapp':
        case 'whatsapp_official':
          return `rgba(7, 188, 76, ${opacity})`
          break
        case 'instagram':
          return `rgba(189, 0, 123, ${opacity})`
          break
        case 'telegram':
          return `rgba(64, 163, 217, ${opacity})`
          break
        case 'sendgrid':
          return `rgba(5, 170, 216, ${opacity})`
          break
        default:
          return `rgba(74, 93, 255, ${opacity})`
      }
    }
  }
}
